import { render, staticRenderFns } from "./StatsCompliments.vue?vue&type=template&id=0ebd446c&"
import script from "./StatsCompliments.vue?vue&type=script&lang=js&"
export * from "./StatsCompliments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports